import { Input } from "@itandi/itandi-bb-ui/Input";
import type React from "react";
import { useFormContext } from "react-hook-form";
import { FormDescription } from "~/components/common/parts/form/FormDescription";
import { FormGroup } from "~/components/common/parts/form/FormGroup";
import { FormLabel } from "~/components/common/parts/form/FormLabel";
import type { ImportConversionParam } from "~/models/ImportConversion";
import Styles from "./AddModalForm.module.scss";

export const AddModalForm: React.FC = () => {
	const { register, formState } = useFormContext<ImportConversionParam>();
	const { errors } = formState;
	return (
		<div>
			<FormGroup>
				<FormLabel>列</FormLabel>
				<Input
					isInvalid={!!errors.columnName?.message}
					placeholder="例：account_key"
					{...register("columnName")}
				/>
				{errors.columnName?.message ? (
					<div className={Styles.InvalidFeedback}>
						{errors.columnName.message}
					</div>
				) : null}
				<FormDescription>
					CSVのヘッダーの列名を小文字で入力してください
				</FormDescription>
			</FormGroup>
			<FormGroup>
				<FormLabel>変換前の値</FormLabel>
				<Input
					isInvalid={!!errors.originalValue?.message}
					placeholder="例：渋谷支店"
					{...register("originalValue")}
				/>
				{errors.originalValue?.message ? (
					<div className={Styles.InvalidFeedback}>
						{errors.originalValue.message}
					</div>
				) : null}
				<FormDescription>
					CSVに入力されている変換したい文言を入力してください
				</FormDescription>
			</FormGroup>
			<FormGroup>
				<FormLabel>変換後の値</FormLabel>
				<Input
					isInvalid={!!errors.convertedValue?.message}
					placeholder="例：100"
					{...register("convertedValue")}
				/>
				{errors.convertedValue?.message ? (
					<div className={Styles.InvalidFeedback}>
						{errors.convertedValue.message}
					</div>
				) : null}
			</FormGroup>
		</div>
	);
};
